<template>
  <div class="panel-body">

    <div class="button-amount border-bottom">
      <div class="checkbox-wrapper">
        <v-checkbox hide-details
                    :input-value="optionsCount === 1"
                    @click="(evt) => checkBoxClick({evt, box: 1})"></v-checkbox>
        <span class="text">{{$t('message.campaigns.message.oneButton')}}</span>
      </div>
      <div class="checkbox-wrapper">
        <v-checkbox hide-details
                    :input-value="optionsCount === 2"
                    @click="(evt) => checkBoxClick({evt, box: 2})"></v-checkbox>
        <span class="text">{{$t('message.campaigns.message.twoButtons')}}</span>
      </div>
    </div>

    <div class="banner-option border-bottom">
      <app-option-editor :data-title="$t('message.campaigns.message.button1')"
                         :data-max-length="maxLength"
                         :data-interaction="interactionStored"
                         :data-option="interactionStored.opcoes[0]"
                         @change="(evt) => $emit('update-option', {option: interactionStored.opcoes[0], data: {nome: evt}})"
                         @change-auth="(evt) => $emit('update-option', {option: interactionStored.opcoes[0], data: {paginaPosAutenticacao: evt}})"
                         @reload="emitReload">
      </app-option-editor>
    </div>

    <div class="banner-option border-bottom"
         v-if="interactionStored.opcoes.length > 1">
      <app-option-editor :data-title="$t('message.campaigns.message.button2')"
                         :data-max-length="maxLength"
                         :data-interaction="interactionStored"
                         :data-option="interactionStored.opcoes[1]"
                         @change="(evt) => $emit('update-option', {option: interactionStored.opcoes[1], data: {nome: evt}})"
                         @change-auth="(evt) => $emit('update-option', {option: interactionStored.opcoes[1], data: {paginaPosAutenticacao: evt}})"
                         @reload="emitReload">
      </app-option-editor>
    </div>
  </div>
</template>

<script>
    import AppOptionEditor from './OptionEditor'
    import panelBody from '../mixins/panel-body'
    import _ from 'lodash'

    export default {
        components: {
            AppOptionEditor
        },

        data() {
          return {
            hasBackgroundColor: false,

          }
        },

        computed: {
            maxLength() {
                return this.interactionStored.opcoes.length === 1 ? 22 : 12
            },
        },

        methods: {
            checkBoxClick({evt, box}) {
                evt.preventDefault()
                evt.stopPropagation()

                if (box === 2 && this.optionsCount === 1)
                    this.$emit('add-option')

                const lastOption = _.maxBy(this.interactionStored.opcoes, (option) => {
                    return option.ordem
                })

                if (box === 1 && this.optionsCount === 2)
                    this.$emit('remove-option', lastOption)
            },

            emitReload() {
              this.$emit('reload')
            },
        },

        mixins: [panelBody],
    }
</script>

<style lang="scss" scoped>
@import "../mixins/panel-body";

.button-amount {
  display: flex;
  justify-content: space-between;
  padding: 10px 30px;
  font-size: 14px;
  font-weight: bold;

  .checkbox-wrapper {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    .text {
      margin: 4px 0 0 -6px;
    }
  }
}

.minimum-time-card {
    display: flex;
    align-items: center;
    font-size: 14px;
}

.minimum-time-input {
    padding: 2px;
    border-bottom: 1px solid black;
    max-width: 32px;
    margin-inline: 8px;
    text-align: center;
    font-size: 14px;

    &::-webkit-outer-spin-button, &::-webkit-inner-spin-button {
        -webkit-appearance: none;
         margin: 0;
    }

    &:focus {
        outline: none;
    }

    input[type=number] {
        -moz-appearance: textfield;
    }
}

.minimum-time-error {
    font-size: 12px;
}

.banner-configuration-section {
    .banner-configuration-section-form {
        display: flex;
        flex-direction: column;

        .banner-configuration-section-form-submit-button {
            align-self: center;
            margin-top: 15px;
        }
    }
}
</style>
